import Header from "./components/Header";
import Carousel from "./components/Carousel";
import CarouselMain from "./components/CarouselMain";
import Call from "./components/Call";
import PorqueElegirnos from "./components/PorqueElegirnos";
import Services from "./components/Services";
import Footer from "./components/Footer";
import ImgStart from "./components/ImgStart";
import Formulario from "./components/Formulario"
import CompanyBrochureCTA from "./components/CompanyBrochureCTA";
import Bot from "./components/Bot";
import BotCta from "./components/BotCta";

function App() {
  return (
    <div>
      <Header />
      <CarouselMain />
      <ImgStart />
      <Carousel />
      <Call />
      <PorqueElegirnos />
      <Services />
      <CompanyBrochureCTA />
      <Formulario/>
      <Bot />
      <BotCta />
      <Footer />
    </div>
  );
}

export default App;
